import React from 'react';
import useAtlasV2KeywordSearchRequestBuilder from 'src/components/AtlasV2Components/AtlasV2Sidebar/AtlasV2SearchSidebar/useAtlasV2KeywordSearchRequestBuilder';
import BeaconDropdownMetricColumnChart from 'src/components/BeaconV2Components/BeaconMetricColumnChart/BeaconDropdownMetricColumnChart';
import TopEntityChartV2Loading from 'src/components/BeaconV2Components/TopEntityChartV2/TopEntityChartV2Loading';
import AdvancedSearchRequestBuilder from 'src/components/BeaconV2Components/utils/AdvancedSearchRequestBuilder';
import { useMainEntityType } from 'src/utils/Hooks/reduxSelectors';

export const AtlasV2KeywordAdClicksColumnChart = ({
  builderFunction
}: {
  builderFunction?: (
    additionalBuilder?: (builder: AdvancedSearchRequestBuilder) => AdvancedSearchRequestBuilder
  ) => (requestBuilder: AdvancedSearchRequestBuilder) => AdvancedSearchRequestBuilder;
}) => {
  const entityType = useMainEntityType();
  const keywordSearchRequestBuilder = useAtlasV2KeywordSearchRequestBuilder();
  const builderToUse = builderFunction || keywordSearchRequestBuilder;
  return (
    <BeaconDropdownMetricColumnChart
      useAdvancedSearchDataArgs={{
        requestBuilder: builderToUse((builder) => {
          return builder;
        })
      }}
      beaconChartWithLegendPropsBuilder={(props) => ({
        ...props,
        loadingComponent: <TopEntityChartV2Loading />
      })}
      indexName="traffic"
      fieldName="adClicks"
      dropdownOptions={[
        {
          id: 'brandId',
          label: 'Brand'
        },
        {
          id: 'categoryId',
          label: 'Category'
        },
        {
          id: 'subCategoryId',
          label: 'Subcategory'
        }
      ].filter((option) => !option.id.toLowerCase().startsWith(entityType))}
      titlePrefix="Ad Clicks by"
    />
  );
};
